export function exportToCsv(filename: string, headers: string[], rows: string[][]): void {
  const escape = (cell: string): string => {
    if (cell.includes(",") || cell.includes('"') || cell.includes("\n")) {
      return `"${cell.replace(/"/g, '""')}"`;
    }
    return cell;
  };

  const lines = [headers, ...rows].map((row) => row.map(escape).join(","));
  const csv = lines.join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function exportToText(filename: string, text: string): void {
  const blob = new Blob([text], {
    type: "text/plain;charset=utf-8",
  });

  //downloadBlob(blob, filename);
}
